<script lang="ts">
	import { onMount } from 'svelte';
	import { currentPath } from './lib/router';

	// Import all page components
	import HomePage from './routes/+page.svelte';
	import RegisterPage from './routes/register/+page.svelte';
	import LoginPage from './routes/login/+page.svelte';
	import ForgotPasswordPage from './routes/forgot-password/+page.svelte';
	import DashboardPage from './routes/dashboard/+page.svelte';
	import BlogPage from './routes/blog/+page.svelte';
	import BlogPostPage from './routes/blog/[slug]/+page.svelte';
	import AboutPage from './routes/about/+page.svelte';
	import CareersPage from './routes/careers/+page.svelte';
	import ContactPage from './routes/contact/+page.svelte';
	import PricingPage from './routes/pricing/+page.svelte';
	import StartPage from './routes/start/+page.svelte';
	import HowItWorksPage from './routes/how-it-works/+page.svelte';
	import LegalPage from './routes/legal/+page.svelte';
	import LegalPrivacyPage from './routes/legal/privacy/+page.svelte';
	import LegalTermsPage from './routes/legal/terms/+page.svelte';
	import LegalSecurityPage from './routes/legal/security/+page.svelte';
	import Layout from './components/Layout.svelte';

	let currentComponent: any;
	let componentProps: any = {};

	onMount(() => {
		// Set initial path
		currentPath.set(window.location.pathname);

		// Listen for URL changes to ensure sync
		const handleNavigation = () => {
			currentPath.set(window.location.pathname);
		};

		// Listen for back/forward navigation
		window.addEventListener('popstate', handleNavigation);

		// Also listen for any URL changes via a polling mechanism as fallback
		const handleUrlChange = () => {
			const newPath = window.location.pathname;
			currentPath.update(currentPathValue => {
				if (currentPathValue !== newPath) {
					return newPath;
				}
				return currentPathValue;
			});
		};

		// Check for URL changes every 100ms as a fallback
		const interval = setInterval(handleUrlChange, 100);

		return () => {
			window.removeEventListener('popstate', handleNavigation);
			clearInterval(interval);
		};
	});

	// Route component based on path
	$: {
		const path = $currentPath;
		componentProps = {};

		// Handle dynamic blog routes with slugs
		if (path.match(/^\/blog\/[a-z0-9-]+$/)) {
			const slug = path.split('/')[2];
			currentComponent = BlogPostPage;
			componentProps = { slug };
		} else {
			// Handle static routes
			switch (path) {
				case '/':
					currentComponent = HomePage;
					break;
				case '/register':
					currentComponent = RegisterPage;
					break;
				case '/login':
					currentComponent = LoginPage;
					break;
				case '/forgot-password':
					currentComponent = ForgotPasswordPage;
					break;
				case '/dashboard':
					currentComponent = DashboardPage;
					break;
				case '/blog':
					currentComponent = BlogPage;
					break;
				case '/about':
					currentComponent = AboutPage;
					break;
				case '/careers':
					currentComponent = CareersPage;
					break;
				case '/contact':
					currentComponent = ContactPage;
					break;
				case '/pricing':
					currentComponent = PricingPage;
					break;
				case '/start':
					currentComponent = StartPage;
					break;
				case '/how-it-works':
					currentComponent = HowItWorksPage;
					break;
				case '/legal':
					currentComponent = LegalPage;
					break;
				case '/legal/privacy':
					currentComponent = LegalPrivacyPage;
					break;
				case '/legal/terms':
					currentComponent = LegalTermsPage;
					break;
				case '/legal/security':
					currentComponent = LegalSecurityPage;
					break;
				default:
					currentComponent = HomePage;
			}
		}
	}
</script>

<Layout>
	{#key currentComponent}
		<svelte:component this={currentComponent} {...componentProps} />
	{/key}
</Layout>

<style>
	:global(html, body) {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
	}

</style>
